import { RadioClassKey } from '@material-ui/core/Radio';
import { CSSProperties } from '@material-ui/core/styles/withStyles';

export const THDRadioStyles: Partial<Record<RadioClassKey, CSSProperties>> = {
  root: {
    border: '0px',
    padding: '6px 6px 6px 0px',
    '&$checked': {
      '&$checked': {
        color: '#f96302',
      },
    },
  },
  checked: {},
  disabled: {},
  colorPrimary: {
    '&$checked': {
      color: '#F96302',
    },
    '&$disabled': {
      opacity: 0.3,
    },
  },
  colorSecondary: {
    '&$checked': {
      color: '#F96302',
      '&:hover': {
        backgroundColor: 'none',
      },
    },
    '&$disabled': {
      opacity: 0.3,
    },
  },
};
